import { DateField, TextField } from "react-admin";

import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { translate } from "react-admin";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { translate } = props;

  const { "event-notifier": highlightedEventNotifierIds = [] } =
    useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedEventNotifierIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      perPage={10}
      split
      type="table"
      filters={<Filters />}
      infoMessage={
        <span style={{ color: "red", fontWeight: "bold" }}>
          {translate("resources.notifiers.info.message")}
        </span>
      }
      key={highlightedEventNotifierIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        target="event-notifier"
        rowBreakpoint="sm"
        cardContent={<Card />}
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="code" variant="body2" />
        <TextField source="name" />
        <DateField source="modified" showTime />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default translate(List);
